import Vue from 'vue'
import $router from './router'

const store = Vue.observable({

    // Active par défaut la phase d'initialisation
    init: true,

    // Indicateur de fin du processus d'inscription: permettra le renvoi vers l'Init.vue en cas de retour en arrière après l'inscription
    endOfInscription: false,

    // Token d'authentification
    token: null,

    // Cible une target a l'ouverture de la FAQ
    faqTarget: null,

    // Accueil.vue
    pension: null,
    horsUe: null,
    adherentCfe: null,
    assureCnarefe: null,
    activiteProfessionnelle: null,

    // Stepper.vue
    stepper: {
        identite: {
            libelle: 'Identité',
            visited: false,
            actived: false
        },
        coordonnees: {
            libelle: 'Coordonnées',
            visited: false,
            actived: false
        },
        regulariteDeSejour: {
            libelle: 'Régularité de séjour',
            visited: false,
            actived: false
        },
        piecesAJoindre: {
            libelle: 'Pièces à joindre',
            visited: false,
            actived: false
        },
        validation: {
            libelle: 'Validation',
            visited: false,
            actived: false
        }
    },

    // Identite.vue
    nomNaissance: null,
    nomNaissanceState: null,
    nomUsage: null,
    nomUsageState: null,
    prenom: null,
    prenomState: null,
    dateNaissance: null,
    dateNaissanceState: null,
    moins55Ans: null,
    lieuNaissance: null,
    lieuNaissanceState: null,
    lieuxNaissance: [],
    nni: null,
    nniState: null,
    cleNni: null,
    cleNniState: null,
    affiliation: null,
    nationalite: null,
    nationaliteState: null,
    carteVitale: null,

    // Coordonnees.vue
    adresseEtranger: null,
    adresseEtrangerState: null,
    paysEtranger: null,
    adressesEtranger: [],
    paysResidence: {},
    paysResidenceState: null,
    listePaysResidence: [],
    provinceCanada: null,
    provinceCanadaState: null,
    quinzeAnneesCotisations: null,
    nationaliteFrCa: null,
    nationaliteFrCaState: null,
    pensionMultiOrigines: null,
    pensionMultiOriginesState: null,
    email: null,
    emailState: null,
    adresseTempoFrance: 0,
    nomHoteAdresseFrance: null,
    nomHoteAdresseFranceState: null,
    adresseFrance: null,
    adresseFranceState: null,
    adressesFrance: [],
    communeFrance: null,
    communeFranceState: null,
    communesFrance: [],

    // RegulariteDeSejour.vue
    titreAutreVisaSchengen: 0,
    disabledTitreAutreVisaSchengen: false,
    visaSchengen: 0,
    disabledVisaSchengen: false,
    passeportAutorisantSejour: 0,
    disabledPasseportAutorisantSejour: false,
    possessionTitreSejour: null,

    // PiecesAJoindre.vue
    fileUploader: {},
    // MODELE TYPE
    // fileUploader: {
    //     'piece-identite': {
    //         state: 0,
    //         files: {
    //             0: {
    //                 file: { "données du fichier (name, size ...)" },
    //                 uploadPercentage: 56,
    //                 controller: controller,
    //                 id: 38,
    //                 deletingProgress: false
    //             },
    //             1: {
    //                 file: { "données du fichier (name, size ...)" },
    //                 uploadPercentage: 100,
    //                 controller: controller,
    //                 id: 39,
    //                 deletingProgress: false
    //             },
    //             ...
    //         }
    //     },
    //     ...
    // },

    // Validation.vue
    ouvertureCompteAmeli: 0,
    acceptationReglesUtilisation: null,
    adhesionAssuranceMaladieRegimeGeneral: null,
    captcha: null,
    captchaResponse: null,
    captchaResponseState: null,

    // Check global de chaque étape (savoir si l'étape est correctement renseignée)
    stepChecked: {
        accueil: null,
        identite: null,
        coordonnees: null,
        regulariteDeSejour: null,
        piecesAJoindre: null,
        validation: null
    }
});

const actions = {

    // Fonction de routage centralisé ici
    router(name, params) {
        params = (params) ? params : null;
        $router.push({
            name: name,
            params: params
            //     params: {
            //       // name: this.theme.libelle,
            //       // title: "Ceci est un titre",
            //       // buttonTitle: "Modifier",
            //       // action: 'update'
            //     }
        })
    },

    // Affecte l'état d'une étape, en initialisant les autres étapes positionnées en aval et en amont
    setStepper(step, state) {
        // Remet a null les actived de chaque étape
        for (var name in store.stepper) {
            store.stepper[name].actived = false
        }
        // Affecte l'étape
        store.stepper[step].visited = state.visited;
        store.stepper[step].actived = state.actived;
    },

    // Renvoi l'état d'une étape (step)
    getStepper(step) {
        return store.stepper[step];
    },

    // Affecte un status global par étape, pour savoir si l'étape est correctement remplie
    setStepChecked(step, state) {
        store.stepChecked[step] = state;
    },

    // Renvoi le state global d'une étape
    getStepChecked(step) {
        return store.stepChecked[step];
    },

    // Un name ne devra pas contenir de caractères particuliers, et contenir au moins deux lettres consécutives
    controlName(name) {
        let regExp1 = /[^A-Za-zàâéèêîôùû \-']/gi;
        let regExp2 = /[A-Za-zàâéèêîôùû]{2,}/gi;
        return !name.match(regExp1) && name.match(regExp2);
    },

    // Ouvre la FAQ en précisant éventuellement une target à l'ouverture. bvModal correspond a this.$bvModal des objets Bootstrap-vue représentant les toutes les modal
    showFaq(bvModal, target) {
        store.faqTarget = target ? target : null
        bvModal.show('modal-faq-cnarefe')
    }

};

// Met à dispo en prototype le fichier de config.json et les autres données du store pour les partager entre chaque composants
Vue.prototype.$store = store;
Vue.prototype.$actions = actions;



// WEBPACK FOOTER //
// ./src/store.js